import React, { useRef, useEffect, useState } from 'react';
import { useField } from '@unform/core';
import { FiX } from 'react-icons/fi';

import {
  Container,
  TextArea as TextAreaBase,
  ErrorMessage,
  RemainingChars,
} from './styles';

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  id?: string;
  height?: string | number; //Remover o number futuramente
  max?: number;
  disable?: boolean; // Renomear futuramente para disabled
  icon?: string; // Remover futuramente
  errorField?: string; // Remover futuramente
}
const TextArea = ({
  name,
  height,
  max,
  disable,
  disabled,
  ...rest
}: TextAreaProps) => {
  const ref = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const [count, setCount] = useState(0);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: 'value',
      setValue: (ref, value) => {
        ref.value = value;
      },
      clearValue: ref => {
        ref.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container height={height}>
      <TextAreaBase
        name={name}
        defaultValue={defaultValue}
        $error={error}
        ref={ref}
        height={height as string}
        autoComplete="false"
        onChange={e => setCount(e.target.value.length)}
        maxLength={max}
        disabled={disable || disabled}
        {...rest}
      />
      {!!error && (
        <i>
          <FiX />
        </i>
      )}
      <div>
        <ErrorMessage>{error}</ErrorMessage>
        {max && (
          <RemainingChars>
            {count}/{max} caracteres
          </RemainingChars>
        )}
      </div>
    </Container>
  );
};

export default TextArea;
